export const tabs = {
    organ: [
        {
            id: 0,
            title: '器官'
        },
        {
            id: 1,
            title: '脊椎'
        },
    ],
    hearts: [
        {
            id: 0,
            title: '健康总评'
        },
        {
            id: 1,
            title: '心脑血管风险管理建议'
        },
    ],
    thyroid: [
        {
            id: 0,
            title: '健康总评'
        },
        {
            id: 1,
            title: '甲状腺健康风险评级'
        },
    ],
    risks: [
        {
            id: 0,
            title: '健康总评'
        },
        {
            id: 1,
            title: '风险评估'
        },
        {
            id: 2,
            title: '健康管理建议'
        },
    ],
    diseasa: [
        {
            id: 0,
            title: '健康总评'
        },
        {
            id: 1,
            title: '慢性病风险评估'
        },
        {
            id: 2,
            title: '健康管理建议'
        },
    ]
}